module.exports = __webpack_public_path__ + "f5e4ecff6d044bfa0e4cbb7d045ce7a7.png";